<div class="form-control-checkbox" [class.has-error]="showError">
  <div class="form-check form-control" [attr.data-testing-id]="'checkout-review-wrapper'">
    <label [attr.for]="id">
      <input
        type="checkbox"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [attr.data-testing-id]="field.key"
        [attr.aria-required]="props.required ? 'true' : undefined"
        [attr.aria-invalid]="showError ? 'true' : undefined"
        [attr.aria-describedby]="props.ariaDescribedByIds"
      />
      <span
        [ishServerHtml]="'checkout.tac.text' | translate : { '0': 'page://page.termsAndConditions.pagelet2-Page' }"
      ></span>
    </label>
  </div>
  <ng-container *ngIf="showError">
    <div class="validation-message">
      <ish-validation-message [field]="field" class="validation-message" />
    </div>
  </ng-container>
</div>
